<template>
  <div class="subscribed-channels-template" theme>
    <div id="theme-subscribed-channels-header" />
    <div id="theme-subscribed-channels-leftside" />
    <div id="theme-subscribed-channels-content" />
    <div id="theme-subscribed-channels-rightside" />
    <div id="theme-subscribed-channels-footer" />
    <b-modal
      id="delete-subscribe-confirm-modal"
      ref="deleteSubscribeConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteSubscribe()"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'subscribed-channels',
      parts: [
        {
          elem: '#theme-subscribed-channels-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-subscribed-channels-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-subscribed-channels-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-subscribed-channels-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-subscribed-channels-footer',
          htmlFile: 'footer'
        }
      ]
    }
  },
  mounted() {
    this.$eventHub.$on(
      'delete-subscribe-confirm',
      this.onDeleteSubscribeConfirm
    )
  },
  beforeDestroy() {
    this.$eventHub.$off(
      'delete-subscribe-confirm',
      this.onDeleteSubscribeConfirm
    )
  },
  methods: {
    onDeleteSubscribeConfirm(params) {
      if (this.componentId === params.componentId) {
        this.deleteSubscribeTarget = params.subscribe
        this.showModal('deleteSubscribeConfirmModalRef')
      }
    },
    deleteSubscribe() {
      this.$axios
        .$put('channel/unsubscribe', this.deleteSubscribeTarget.chnnel)
        .then(response => {
          if (response.resultCode === 'success') {
            $('[subscribe-id=' + this.deleteSubscribeTarget.id + ']').remove()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    }
  }
}
</script>

<style scoped>
.subscribed-channels-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
